import "./index.sass";
import LoginForm from "../../components/LoginForm";

// --- Google-only login. The username / password / OTP flow below is kept ----
// --- commented for reference; uncomment (and re-enable the old LoginForm) ---
// --- to bring it back. -----------------------------------------------------
//
// import React, { useState } from "react";
// import { useHistory } from "react-router-dom"
// import { useDispatch, useSelector } from "react-redux";
// import decode from "jwt-decode";
// import SecureStorage from "../../config/SecureStorage";
// import {
//   login,
//   fetchShortProfile,
//   sendLoginMobileOtp,
//   verifyLoginMobileOtp,
// } from "../../actions/loginActions";
// import snackBarUpdate from "../../actions/snackBarActions";
//
// // Usergroups that must verify a phone OTP on the login page before entering.
// const OTP_USERGROUPS = ["OffLineSupport"];

export default function Login() {
  // const dispatch = useDispatch();
  // const history = useHistory()
  // const { loading, loadingOTP } = useSelector((state: any) => state.loginReducer);
  //
  // // OTP-step state, only used for the restricted usergroups above.
  // const [otpStep, setOtpStep] = useState(false);
  // const [phoneNumber, setPhoneNumber] = useState<string>("");
  // const [otp, setOtp] = useState<string>("");
  // const [otpLoading, setOtpLoading] = useState(false);
  //
  // const handleForm = async (form: object) => {
  //   try {
  //     await dispatch(login(form))
  //
  //     // Read the usergroup straight from the freshly-stored JWT.
  //     // The login action stores the token via SecureStorage.
  //     let group = "";
  //     try {
  //       const decoded: any = decode(SecureStorage.getItem("token"));
  //       group = decoded?.user_group || "";
  //     } catch (e) {
  //       group = "";
  //     }
  //
  //     if (!OTP_USERGROUPS.includes(group)) {
  //       history.push('/dashboard');
  //       return;
  //     }
  //
  //     // OTP-required panel: fetch phone from short profile, auto-send OTP,
  //     // and show the OTP entry step on the login page instead of the dashboard.
  //     setOtpLoading(true);
  //     try {
  //       const profile = await fetchShortProfile();
  //       const phone = profile?.profile?.phonenumber || "";
  //       setPhoneNumber(phone);
  //       await sendLoginMobileOtp(phone);
  //       setOtpStep(true);
  //       snackBarUpdate({
  //         payload: {
  //           message: "OTP sent to your registered mobile number",
  //           status: true,
  //           type: "success",
  //         },
  //       })(dispatch);
  //     } catch (otpErr) {
  //       snackBarUpdate({
  //         payload: {
  //           message: "Could not send OTP. Please try again.",
  //           status: true,
  //           type: "error",
  //         },
  //       })(dispatch);
  //     } finally {
  //       setOtpLoading(false);
  //     }
  //   } catch (error) {
  //     return error;
  //   }
  // };
  //
  // const handleResendOtp = async () => {
  //   setOtpLoading(true);
  //   try {
  //     await sendLoginMobileOtp(phoneNumber);
  //     snackBarUpdate({
  //       payload: {
  //         message: "OTP resent to your registered mobile number",
  //         status: true,
  //         type: "success",
  //       },
  //     })(dispatch);
  //   } catch (e) {
  //     snackBarUpdate({
  //       payload: {
  //         message: "Could not resend OTP. Please try again.",
  //         status: true,
  //         type: "error",
  //       },
  //     })(dispatch);
  //   } finally {
  //     setOtpLoading(false);
  //   }
  // };
  //
  // const handleBack = () => {
  //   setOtpStep(false);
  //   setOtp("");
  //   setPhoneNumber("");
  // };
  //
  // const handleVerifyOtp = async () => {
  //   setOtpLoading(true);
  //   try {
  //     await verifyLoginMobileOtp(phoneNumber, otp);
  //     history.push('/dashboard');
  //   } catch (e) {
  //     snackBarUpdate({
  //       payload: {
  //         message: "Invalid OTP. Please try again.",
  //         status: true,
  //         type: "error",
  //       },
  //     })(dispatch);
  //   } finally {
  //     setOtpLoading(false);
  //   }
  // };

  return (
    <div className="login-container" >
      <div className="mainHeading">
        <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/bf8ae4e8-1f26-45a6-8011-938ad23ad65a.svg" alt="" style={{ width: "350px" }} />
        <p style={{ fontSize: "30px", color: "white" }}>Healthy India Ki Trusted Lab</p>
      </div>
      <div className="login-container__form">
        {/* Google-only login form. */}
        <LoginForm />
        {/* Old username / password / OTP form — pass these props to re-enable:
        <LoginForm
          loading={loading || otpLoading}
          loadingOTP={loadingOTP}
          handleForm={handleForm}
          otpStep={otpStep}
          otp={otp}
          setOtp={setOtp}
          phoneNumber={phoneNumber}
          otpLoading={otpLoading}
          onVerifyOtp={handleVerifyOtp}
          onResendOtp={handleResendOtp}
          onBack={handleBack}
        /> */}
      </div>
    </div>
  );
}
